import React from "react";
import {Badge} from "reactstrap";
import {RefreshCw} from "react-feather";
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';
import NumberFormat from "./NumberFormat";

const getColor = (number) => {
    if (number < 1) number = 1;
    if (number > 10) number = 10;

    const colors = [
        "#4CAF50",
        "#8BC34A",
        "#CDDC39",
        "#FFEB3B",
        "#FFC107",
        "#FF9800",
        "#FF5722",
        "#F44336",
        "#E53935",
        "#D32F2F"
    ];

    return colors[number - 1];
}

const BatchInfo = ({batch, ismanual, isreprocessing, user}) => {
    return <>
        <Badge style={{ backgroundColor: getColor(batch), color: "#fff" }} className="mr-1 mb-1">{batch}</Badge>
        {(ismanual === 1 || isreprocessing === 1) &&
            <Tippy content={<span>{ismanual === 1 && 'Manually '}{isreprocessing === 1 && 'Re-Processed '}{user ? ' by '+user.name : ''}</span>}><RefreshCw size={16}/></Tippy>
        }
    </>
}

export default BatchInfo;
